import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  onClick?: () => void;
  as?: "button" | "a";
  href?: string;
}>;

export default function CTAButton({ children, onClick, as = "button", href }: Props) {
  const base =
    "inline-flex items-center justify-center gap-2 px-5 py-3 rounded-2xl font-medium " +
    "bg-gradient-to-r from-indigo-500 via-fuchsia-500 to-emerald-500 " +
    "text-white shadow-lg shadow-indigo-500/25 hover:opacity-95 transition text-sm md:text-base";

  if (as === "a" && href) {
    return (
      <a className={base} href={href} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  }
  return (
    <button className={base} onClick={onClick}>
      {children}
    </button>
  );
}

